export const tableColumns = [
    {
        name: 'ID',
        selector: row => row.id,
        sortable: true,
        center: true,
        maxWidth: '3.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Previous Amount',
        selector: row => row.previous_amount,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'New Amount',
        selector: row => row.new_amount,
        sortable: true,
        center: true,
        maxWidth: '9.375rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Modified by',
        selector: row => row.modified_by,
        sortable: true,
        center: true,
        maxWidth: '9.5rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    },
    {
        name: 'Modified date',
        selector: row => row.modified_date,
        sortable: true,
        center: true,
        maxWidth: '9.5rem',
        style: {
            whiteSpace: 'wrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis'
        }
    }
];